(() => {
  "use strict";

  window.MinacoHeaderFeatures = window.MinacoHeaderFeatures || {};

  window.MinacoHeaderFeatures.mega = (MinacoHeader, SELECTORS) => {
    class MinacoHeaderMegaFeature {
    bindHeaderZones() {
      const zones = [
        this.navigationZone,
        this.logoZone,
        this.actionsZone,
      ].filter(Boolean);

      zones.forEach((zone) => {
        this.on(zone, "pointerenter", (event) => {
          if (!this.isFinePointer(event)) {
            return;
          }

          this.clearTimer("transparent");
          this.pointerSolid = true;

          if (zone !== this.navigationZone) {
            this.closeMegaMenus({
              reconcile: false,
            });
          }

          this.reconcileState();
        });

        this.on(zone, "pointerleave", (event) => {
          if (!this.isFinePointer(event)) {
            return;
          }

          if (this.relatedTargetIsMenuZone(event.relatedTarget)) {
            return;
          }

          if (zone === this.navigationZone) {
            this.scheduleMegaClose();
          }

          this.scheduleTransparentRestore();
        });
      });

      this.header.querySelectorAll(SELECTORS.normalNavItem).forEach((item) => {
        this.on(item, "pointerenter", (event) => {
          if (!this.isFinePointer(event)) {
            return;
          }

          this.clearTimer("megaClose");

          this.closeMegaMenus({
            reconcile: false,
          });

          this.pointerSolid = true;
          this.reconcileState();
        });
      });
    }

    bindMegaMenus() {
      this.megaTriggers.forEach((trigger) => {
        const button = trigger.querySelector("button");
        const handle = trigger.dataset.menuHandle;

        if (!button || !handle) {
          return;
        }

        this.on(trigger, "pointerenter", (event) => {
          if (!this.isFinePointer(event) || !this.desktopMedia.matches) {
            return;
          }

          this.openMegaMenu(handle, trigger);
        });

        this.on(button, "click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const selectedMenu = this.getMegaMenu(handle);

          if (!selectedMenu) {
            return;
          }

          if (selectedMenu === this.activeMegaMenu) {
            if (this.hoverMedia.matches && trigger.matches(":hover")) {
              this.updateMegaHeight(selectedMenu);
            } else {
              this.closeMegaMenus({
                restoreFocus: false,
              });
            }
          } else {
            this.openMegaMenu(handle, trigger);
          }
        });

        this.on(button, "keydown", (event) => {
          if (event.key !== "ArrowDown") {
            return;
          }

          event.preventDefault();

          this.openMegaMenu(handle, trigger);

          this.setTimer(
            "megaFocus",
            () => {
              this.firstFocusable(this.activeMegaMenu)?.focus();
            },
            0,
          );
        });
      });

      this.megaMenus.forEach((menu) => {
        this.on(menu, "pointerenter", (event) => {
          if (!this.isFinePointer(event)) {
            return;
          }

          this.clearTimer("megaClose");
          this.clearTimer("transparent");

          this.pointerSolid = true;

          this.updateMegaHeight(menu);
          this.reconcileState();
        });

        this.on(menu, "pointerleave", (event) => {
          if (!this.isFinePointer(event)) {
            return;
          }

          if (this.relatedTargetIsMenuZone(event.relatedTarget)) {
            return;
          }

          this.scheduleMegaClose();
          this.scheduleTransparentRestore();
        });
      });
    }

    openMegaMenu(handle, trigger = null) {
      if (!this.desktopMedia.matches) {
        return;
      }

      const selectedMenu = this.getMegaMenu(handle);

      if (!selectedMenu) {
        return;
      }

      this.clearTimer("megaClose");
      this.clearTimer("megaReset");
      this.clearTimer("transparent");

      this.closeSearch({
        reconcile: false,
      });

      this.closeCountrySelector({
        reconcile: false,
      });

      this.closeMobileDrawer({
        reconcile: false,
      });

      this.activeMegaMenu = selectedMenu;

      this.activeMegaTrigger =
        trigger ||
        this.megaTriggers.find((item) => item.dataset.menuHandle === handle) ||
        null;

      this.pointerSolid = true;

      this.megaMenus.forEach((menu) => {
        const open = menu === selectedMenu;

        menu.classList.toggle("is-open", open);
        menu.setAttribute("aria-hidden", open ? "false" : "true");
      });

      this.megaTriggers.forEach((item) => {
        const open = item === this.activeMegaTrigger;

        item.classList.toggle("is-active", open);

        item
          .querySelector("button")
          ?.setAttribute("aria-expanded", open ? "true" : "false");
      });

      this.reconcileState();
      this.updateMegaHeight(selectedMenu);

      window.requestAnimationFrame(() => {
        if (this.activeMegaMenu !== selectedMenu) {
          return;
        }

        this.updateMegaHeight(selectedMenu);

        window.requestAnimationFrame(() => {
          if (this.activeMegaMenu === selectedMenu) {
            this.updateMegaHeight(selectedMenu);
          }
        });
      });
    }

    closeMegaMenus({
      restoreFocus = false,
      reconcile = true,
      immediateReset = false,
    } = {}) {
      this.clearTimer("megaClose");

      const returnButton = this.activeMegaTrigger?.querySelector("button");

      this.megaMenus.forEach((menu) => {
        menu.classList.remove("is-open");
        menu.setAttribute("aria-hidden", "true");
      });

      this.megaTriggers.forEach((trigger) => {
        trigger.classList.remove("is-active");

        trigger.querySelector("button")?.setAttribute("aria-expanded", "false");
      });

      this.activeMegaMenu = null;
      this.activeMegaTrigger = null;

      if (immediateReset || this.reducedMotionMedia.matches) {
        this.resetMegaHeight();
      } else {
        this.setTimer(
          "megaReset",
          () => {
            if (!this.activeMegaMenu) {
              this.resetMegaHeight();
            }
          },
          520,
        );
      }

      if (reconcile) {
        this.reconcileState();
      }

      if (restoreFocus) {
        returnButton?.focus();
      }
    }

    scheduleMegaClose() {
      this.setTimer(
        "megaClose",
        () => {
          if (this.isPointerInsideMenuZone()) {
            return;
          }

          this.closeMegaMenus({
            reconcile: false,
          });

          this.pointerSolid = this.isPointerInsideHeaderZone();

          this.reconcileState();
        },
        this.megaCloseDelay,
      );
    }

    getMegaMenu(handle) {
      return this.megaMenus.find((menu) => menu.dataset.menuHandle === handle);
    }

    updateMegaHeight(menu) {
      if (!menu) {
        return;
      }

      const headerHeight = Math.ceil(
        this.main?.getBoundingClientRect().height ||
          this.header.getBoundingClientRect().height ||
          0,
      );

      const inner = menu.querySelector(SELECTORS.megaInner);

      const submenuHeight = Math.ceil(
        inner?.getBoundingClientRect().height ||
          inner?.scrollHeight ||
          menu.scrollHeight ||
          0,
      );

      const fullHeight = headerHeight + submenuHeight;

      this.setHeightVariables(headerHeight, submenuHeight, fullHeight);
    }

    resetMegaHeight() {
      const headerHeight = Math.ceil(
        this.main?.getBoundingClientRect().height ||
          this.header.getBoundingClientRect().height ||
          0,
      );

      this.setHeightVariables(headerHeight, 0, headerHeight);
    }

    }

    Object.getOwnPropertyNames(MinacoHeaderMegaFeature.prototype).forEach((methodName) => {
      if (methodName === "constructor") {
        return;
      }

      Object.defineProperty(
        MinacoHeader.prototype,
        methodName,
        Object.getOwnPropertyDescriptor(MinacoHeaderMegaFeature.prototype, methodName),
      );
    });
  };
})();
